<template>
    <v-card>
        <v-toolbar dark color="primary" flat height="48">
            <v-icon left @click="$emit('close')">arrow_back</v-icon>
            <v-toolbar-title>Validity</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pb-0 pt-3">
            <v-row row="12" class="ma-0 pa-0 pb-0">
                <v-col cols="6" class="mt-0 pt-0 pl-0 pb-0">
                    <v-menu
                      v-model="date_menu_0"
                      offset-y
                      min-width="0"
                      :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                              clearable
                              prepend-inner-icon="event"
                              v-on="on"
                              :value="validity.start_date"
                              @input="(d) => set_start_date(d)"
                              readonly
                              label="Start"/>
                        </template>
                        <v-date-picker
                          :value="validity.start_date"
                          :allowed-dates="d => !validity.end_date || Date.parse(d) < Date.parse(validity.end_date)"
                          @input="(d) => {date_menu_0 = !date_menu_0; set_start_date(d);}"
                          :first-day-of-week="1"/>
                    </v-menu>
                </v-col>
                <v-col cols="6" class="mt-0 pt-0 pr-0 pb-0">
                    <v-menu
                      v-model="date_menu_1"
                      offset-y
                      min-width="0"
                      :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                              clearable
                              prepend-inner-icon="event"
                              v-on="on"
                              :value="validity.end_date"
                              @input="(d) => set_end_date(d)"
                              readonly
                              label="End"/>
                        </template>
                        <v-date-picker
                          :value="validity.end_date"
                          :allowed-dates="d => !validity.start_date || Date.parse(d) > Date.parse(validity.start_date)"
                          @input="(d) => {date_menu_1 = !date_menu_1; set_end_date(d);}"
                          :first-day-of-week="1"/>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'ValidityDialog',
    data () {
        return {
            date_menu_0: false,
            date_menu_1: false
        }
    },
    computed: {
        validity () {
            return this.$store.getters['teacher/validity'];
        }
    },
    methods: {
        set_start_date (d) {
            this.$store.commit('teacher/set_validity_start', d);
        },
        set_end_date (d) {
            this.$store.commit('teacher/set_validity_end', d);
        }
    }
}
</script>
